<template>
  <c-dropdown in-nav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <c-header-nav-link>
        <c-icon name="cil-user" />
      </c-header-nav-link>
    </template>
    <c-dropdown-header tag="div" class="text-center" color="light">
      <strong>{{ $store.state.app.authenticatedUser.firstName }} {{ $store.state.app.authenticatedUser.lastName }}</strong>
    </c-dropdown-header>
    <c-dropdown-item class="mt-2">
      <c-icon name="cil-user" />
      <router-link to="/my-account" class="text-decoration-none dropdown-nav-link">
        Edit Profile
      </router-link>
    </c-dropdown-item>
    <c-dropdown-item>
      <c-icon name="cil-settings" />
      <router-link to="/my-organisation" class="text-decoration-none dropdown-nav-link">Account</router-link>
    </c-dropdown-item>
    <c-dropdown-divider />
    <c-dropdown-item @click="logout">
      <c-icon name="cil-lock-locked" />
      Logout
    </c-dropdown-item>
  </c-dropdown>
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data() {
    return {
      itemsCount: 42,
    };
  },
  methods: {
    logout() {
      this.$auth.logout({
        redirect: '/login',
        makeRequest: false,
        success() {},
        // error: function () {},
        // etc...
      });
    },
  },
};
</script>

<style lang="css" scoped>
.c-icon {
  margin-right: 0.3rem;
}
.dropdown-nav-link {
  color: inherit; width: 100%
}
</style>
